// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__235sD","colBig":"styles_colBig__L964Y","colSmall":"styles_colSmall__GfS20"};